import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_DANHSACHCUAHANG } from "actions/DanhSachCuaHang/actionTypes";
import {
  getDanhSachCuaHangSuccess,
  getDanhSachCuaHangFailure,
} from "actions/DanhSachCuaHang";
import DanhSachCuaHangApi from "service/danhSachCuaHangApi";
import { pushNotification } from "utils/notifications";

function* getDanhSachCuaHang(action) {
  try {
    const response = yield call(
      DanhSachCuaHangApi.getListDanhSachCuaHang,
      action.dataSearch,
    );
    if (response.ok) {
      yield put(getDanhSachCuaHangSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getDanhSachCuaHangFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getDanhSachCuaHangFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_DANHSACHCUAHANG, getDanhSachCuaHang);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
